export const TRANSLATION_CHALLENGES = {
  createChallenge: {
    nextButton: 'global.button.next',
    createButton: 'challenges.button.create_challenge',
    rewardInfo: {
      title: 'create_challenge.reward.title',
      description: 'create_challenge.reward_info.description'
    },
    inputGoalError: 'create_challenge.input_goal_error.helper_text',
    inputGoalMinError: 'create_challenge.input_goal_error.minimum.helper_text',
    challengeReview: {
      challenge: 'global.challenges',
      activity: 'global.activity',
      goal: 'challenge.goal',
      betterflies: 'global.betterflies',
      end: 'global.end'
    }
  },
  hero: {
    mainChallenge: {
      title: 'global.challenges_plural',
      description: 'challenges.hero.description_empty_state',
      button: 'challenges.button.create_challenge'
    },
    createChallenge: {
      title: 'create_challenge.hero.title',
      description: 'create_challenge.hero.choose_type.description'
    },
    selectChallengeDates: {
      description: 'create_challenge.hero.select_date.description'
    },
    challengeGoal: {
      description: 'create_challenge.hero.goal_and_reward.description'
    },
    descriptionChallenge: {
      description: 'create_challenge.hero.describe_challenge.description'
    },
    challengeReview: {
      description: 'create_challenge.hero.review_challenge.description'
    }
  },
  detail: {
    daysLeft: 'challenges.days_left',
    participants: 'challenges.detail.participants',
    insight: 'challenges.detail.insight',
    status: {
      active: 'status.active'
    },
    challengeType: 'global.custom.main',
    listLoading: 'challenges.detail.users_list.service_loading',
    listLoaded: 'challenges.detail.users_list.loaded'
  },
  description: {
    title: 'create_challenge.challenge_title',
    description: 'create_challenge.challenge_description',
    create_challenge: 'create_challenge.challenge_description',
    description_placeholder: 'global.placeholder.input_description',
    title_placeholder: 'global.placeholder.input_title',
    helper_text: 'global.input_helper.character_limit',
    global_title: 'global.title',
    rewards: 'global.rewards'
  }
};

export const TRANSLATIONS_CHALLENGES_MAIN = {
  searchBar: 'search.placeholder.title_and_author',
  table: {
    header: {
      title: 'global.title',
      status: 'global.status',
      type: 'global.type',
      participants: 'global.participants_plural',
      period: 'global.period',
      author: 'global.author'
    },
    filter: {
      active: 'status.active_plural',
      ready: 'status.scheduled_plural',
      finished: 'status.ended_plural'
    },
    status: {
      active: 'status.active',
      ready: 'status.scheduled',
      finished: 'status.ended'
    },
    defaultType: 'challenge_type.other_challenges',
    emptyData: {
      title: 'challenges.empty_state.title',
      description: 'challenges.empty_state.description',
      button: 'challenges.button.create_challenge'
    },
    noSearch: {
      title: 'global.search.no_results.title',
      description: 'global.search.no_results.description'
    },
    seeRanking: 'global.button.see_ranking'
  },
  filter: {
    button: 'global.button.filter',
    title: 'challenges.filter_menu.title',
    bike: 'global.bike',
    training: 'global.training',
    meditation: 'global.meditation',
    steps: 'global.steps',
    donations: 'global.donations',
    tabs: {
      all: 'global.label.all',
      sport: 'global.sport',
      donations: 'global.donations'
    }
  },
  deleteChallenge: {
    title: 'delete_challenge.dialog.title',
    description: 'delete_challenge.dialog.description',
    primaryButton: 'global.confirmation.delete',
    secondaryButton: 'button.close',
    noCollaborators: 'delete_challenge.disabled.tooltip',
    betterfly: 'delete_challenge.by_betterfly.disabled.tooltip'
  }
};
